// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"UploadFile_dropzone__1h-vB","reject":"UploadFile_reject__2Kpgt","accept":"UploadFile_accept__3mK1X","browse-button":"UploadFile_browse-button__2AUZ1"};